import { Reveal } from "@/components/site/Reveal";
import HeroScene from "@/components/home/HeroScene";
import ServiceScenes from "@/components/home/ServiceScenes";
import IndustriesJourney from "@/components/home/IndustriesJourney";
import WhyVerifySection from "@/components/home/WhyVerifySection";
import ContactScene from "@/components/home/ContactScene";

const ABOUT_IMG =
  "https://images.pexels.com/photos/39192345/pexels-photo-39192345.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function CorporateHome() {
  return (
    <main data-testid="corporate-home-page" className="bg-[#f7f4ee] overflow-x-clip">
      <HeroScene />

      {/* ABOUT */}
      <section id="about" className="py-16 sm:py-20 md:py-32 overflow-hidden" data-testid="about-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-9 sm:gap-12 lg:gap-16 items-center">
          <Reveal>
            <h2 className="font-display text-[#12294d] text-3xl sm:text-4xl md:text-6xl tracking-tight" data-testid="about-heading">
              01 — About <span className="text-[#2ab5cf]">MedVerify</span>
            </h2>
            <div className="mt-5 sm:mt-8 text-[0.95rem] sm:text-base md:text-lg" data-testid="about-text"><h3 className="font-bold text-[#2ab5cf] mb-2">Corporate Wellness</h3><p className="text-slate-600 leading-relaxed">MedVerify Services provides Corporate Wellness and Occupational Health services to:</p><ul className="mt-3 space-y-2 list-disc pl-6 text-slate-600 leading-relaxed">
                <li>Promote organizational ROI</li>
                <li>Enhance employee productivity</li>
                <li>Reduce absenteeism</li>
                <li>Support employee wellbeing</li>
                <li>Offer regulatory compliance best practices</li>
                <li>Enable organizations to make informed strategic decisions regarding their employees</li>
              </ul></div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative">
              <img
                src={ABOUT_IMG}
                alt="Occupational health check for a corporate employee"
                className="w-full h-[260px] sm:h-[340px] md:h-[460px] object-cover rounded-[2rem] shadow-xl shadow-[#1a3a6b]/10"
                loading="lazy"
                data-testid="about-image"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <ServiceScenes />
      <WhyVerifySection />
      <IndustriesJourney />
      <ContactScene />
    </main>
  );
}
